import MemberCard from "../models/memberCard";
import { API, getResponseList } from "./axios";

async function getMemberCards(memberCardData: any) {
    // memberCardData['per_page'] = 5;
    const converter = (json: JSON) => MemberCard.fromJson(json);
    return await getResponseList(API.MEMBERCARD, '', memberCardData, converter);
}

export { getMemberCards }